
import Vue from "vue";
import AppDraggableResizeCombo from "@/components/layout-editor/DraggableResizeCombo.vue";
import { Image } from "../../utils/label-layout/image";

export default Vue.extend({
	props: {
		image: {
			type: Object as ()=>Image,
			required: true
		},
	},
	components: {
		AppDraggableResizeCombo
	}
});
